import {AbstractControl, ValidationErrors} from '@angular/forms';
import {Utils} from '@astek/utils';

export function manufactureDateRangeValidator(control: AbstractControl): ValidationErrors | null {
  const manufacturedAtFromControl: AbstractControl<Date | null> | null = control.get('manufacturedAtFrom');
  const manufacturedAtToControl: AbstractControl<Date | null> | null = control.get('manufacturedAtTo');
  if (Utils.isNull(manufacturedAtFromControl) || Utils.isNull(manufacturedAtToControl)) {
    return null;
  }
  switch (true) {
    case Utils.isNull(manufacturedAtFromControl.value) && Utils.isNull(manufacturedAtToControl.value):
      manufacturedAtFromControl.setErrors(null);
      manufacturedAtToControl.setErrors(null);
      break;
    case Utils.isNull(manufacturedAtFromControl.value):
      manufacturedAtFromControl.setErrors({incorrect: true});
      break;
    case Utils.isNull(manufacturedAtToControl.value):
      manufacturedAtToControl.setErrors({incorrect: true});
      break;
    case Utils.isNotNull(manufacturedAtFromControl.value) && Utils.isNotNull(manufacturedAtToControl.value) &&
    manufacturedAtToControl.value < manufacturedAtFromControl.value:
      manufacturedAtToControl.setErrors({incorrect: true});
      break;
    default:
      manufacturedAtFromControl.setErrors(null);
      manufacturedAtToControl.setErrors(null);
  }
  return null;
}
